/** Esito delle azioni percepibile anche al tatto: successo/errore dei messaggi (sonner) → vibrazione breve. */
import { toast } from "sonner";
import { haptic } from "./haptics";

let patched = false;
export function installToastHaptics() {
  if (patched) return;
  patched = true;
  const ok = toast.success.bind(toast);
  const ko = toast.error.bind(toast);
  toast.success = ((...a: Parameters<typeof toast.success>) => {
    haptic.success();
    return ok(...a);
  }) as typeof toast.success;
  toast.error = ((...a: Parameters<typeof toast.error>) => {
    haptic.error();
    return ko(...a);
  }) as typeof toast.error;
}
